export const DEEP_BOX_API_ERROR_MSGS = {
  NODE_MOVE_OUT_OF_BOX_PROHIBITED_SHARED_FOLDER:
    'node.move.out-of-box.prohibited.shared-folder',
  NODE_MOVE_OUT_OF_BOX_PROHIBITED_GENERIC_FOLDER:
    'node.move.out-of-box.prohibited.generic-folder',
  ERROR_MOVE_RECURSIVE: 'error.move.recursive',
}
